import React, { useRef, useEffect } from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import { Container } from "reactstrap";

// import Footer from "components/Footer/Footer.js";

import { authRoutes } from "routes.js";
import AuthNavbar from "components/Navbars/AuthNavbar";
import { isLoggedIn } from "utils";
//import Loader from "components/Loader";

var ps;

function AuthLayout() {
    const mainPanel = useRef();
    const location = useLocation();

    const { isAuthenticated } = useSelector(({ auth: { token } }) => ({
        isAuthenticated: isLoggedIn(token),
    }));

    useEffect(() => {
        if (navigator.platform.indexOf("Win") > -1) {
            ps = new PerfectScrollbar(mainPanel.current);
            document.body.classList.toggle("perfect-scrollbar-on");
        }
        return function cleanup() {
            if (navigator.platform.indexOf("Win") > -1) {
                ps.destroy();
                document.body.classList.toggle("perfect-scrollbar-on");
            }
        };
    }, []);

    useEffect(() => {
        mainPanel.current.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        document.body.style.background = "#262734";
    }, [location]);

    return (
        <div className="wrapper">
            <div ref={mainPanel}>
                <AuthNavbar fluid />
                <Container>
                    {/* <Loader visible={loading} /> */}
                    <Switch>
                        {authRoutes.map((prop, key) => {
                            if (prop.layout === "/auth" && !isAuthenticated) {
                                return <Route path={prop.layout + prop.path} component={prop.component} key={key} />;
                            } else {
                                return <Redirect to={"/app/certificates"} key={key} />;
                            }
                        })}
                        <Redirect from="*" to="/auth/signin" />
                    </Switch>
                </Container>
                {/* <Footer fluid /> */}
            </div>
        </div>
    );
}

export default AuthLayout;
